<template>
  <div class="is-fullhd">
		<div class="box">
      <div class="content has-text-centered">
        <h2 class="is-title is-bold has-text-centered has-text-primary">
          Account Settings
        </h2>
      </div>
      <hr></hr>
	  	<tabs type="boxed" size="medium" id="generalTab">
	      <tab-pane label="User Info" icon="fa fa-user">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Email</label>
                <div class="control">
                  {{this.userInfo.email}}
                </div>
              </div>
            </div>
            <!-- <div class="column">
              <div class="field">
                <label class="label">Role</label>
                <div class="control">
                  {{this.userInfo.role}}
                </div>
              </div>
            </div> -->
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                  <input class="input" v-model="userInfo.firstName" type="text">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Last Name</label>
                <div class="control">
                  <input class="input" v-model="userInfo.lastName" type="text">
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="file is-primary has-name is-fullwidth is-right">
              <label class="file-label">
                <input class="file-input" v-on:change="fileChange()" type="file" name="profilePicture" id="profilePicture">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
                <span class="file-name" style="background: #fff;">
                  {{ pictureName ? pictureName : 'Profile Picture'}}
                </span>
              </label>
            </div>
          </div>
					<div class="field">
					  <p class="control" style="margin-top: 20px; text-align: center;">
					    <button v-on:click="editUser()" class="button is-primary">
					      Submit
					    </button>
					  </p>
					</div>
	      </tab-pane>

	      <tab-pane label="Change Password" icon="fa fa-lock">
	      	<div class="field">
            <label class="label">Old Password</label>
					  <p class="control has-icons-left">
					    <input class="input" type="password" v-model="oldPassword">
					    <span class="icon is-small is-left">
					      <i class="fa fa-lock"></i>
					    </span>
					  </p>
					</div>
	      	<div class="field">
            <label class="label">New Password</label>
					  <p class="control has-icons-left">
					    <input class="input" type="password" v-model="newPassword">
					    <span class="icon is-small is-left">
					      <i class="fa fa-lock"></i>
					    </span>
					  </p>
            <p class="help">Password should be minimum 8 characters which contain at least one numeric digit and a special character.</p>
					</div>
	      	<div class="field">
            <label class="label">Re-type New Password</label>
					  <p class="control has-icons-left">
					    <input class="input" type="password" v-model="rePassword">
					    <span class="icon is-small is-left">
					      <i class="fa fa-lock"></i>
					    </span>
					  </p>
					</div>
					<div class="field">
					  <p class="control" style="margin-top: 20px; text-align: center;">
					    <button class="button is-primary" v-on:click="changePassword()">
					      Submit
					    </button>
					  </p>
					</div>
	      </tab-pane>
	    </tabs>
	  </div>
  </div>
</template>

<script>
import { Tabs, TabPane } from 'vue-bulma-tabs'
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import FormData from 'form-data'
export default {
  components: {
    Tabs,
    TabPane
  },
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      rePassword: '',
      user: '',
      userInfo: {
        firstName: '',
        lastName: '',
        email: '',
        role: ''
      },
      pictureName: ''
    }
  },
  created () {
    // console.log(window.localStorage.getItem('user'))
    let user = JSON.parse(window.localStorage.getItem('user'))
    this.user = user
    axios.get(globalConstants.apiURL + '/api/v1/users/' + user._id)
    .then(response => {
      this.userInfo.firstName = response.data.firstName
      this.userInfo.lastName = response.data.lastName
      this.userInfo.email = response.data.email
      this.userInfo.role = response.data.role
    })
    .catch(error => {
      console.log(error)
    })
  },
  methods: {
    fileChange () {
      var image = document.getElementById('profilePicture').files[0]
      this.pictureName = image.name
    },
    editUser () {
      var image = document.getElementById('profilePicture').files[0]
      var fd = new FormData()
      fd.append('file', image)
      if (this.userInfo.firstName === '') {
        this.$noty.error('Please enter First Name.')
      } else if (this.userInfo.lastName === '') {
        this.$noty.error('Please enter Last Name.')
      } else {
        axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, this.userInfo)
        .then(response => {
          this.$noty.success('Profile updated Successfully.')
          if (image) {
            if (this.user.role === 'companyAdmin') {
              fd.append('profilePictureFlag', 1)
            }
            axios.post(globalConstants.apiURL + '/api/v1/users/' + this.user._id + '/upload', fd, {
              headers: {'Content-Type': undefined}
            }).then(response => {
              this.$store.commit('setUserImageSrc', globalConstants.apiURL + '/' + response.data.path)
              this.pictureName = ''
              this.$noty.success('Profile picture updated Successfully.')
            })
            .catch(error => {
              console.log(error)
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    validatePassword (newPassword) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/
      return re.test(newPassword)
    },
    changePassword () {
      if (this.oldPassword === '') {
        this.$noty.error('Please enter old password.')
      } else if (this.newPassword === '') {
        this.$noty.error('Please enter new password.')
      } else if (!this.validatePassword(this.newPassword)) {
        this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.')
      } else if (this.rePassword === '') {
        this.$noty.error('Please retype new password.')
      } else if (this.newPassword !== this.rePassword) {
        this.$noty.error('Password did not match!!')
      } else {
        axios.put(globalConstants.apiURL + '/api/v1/users/' + this.user._id, {oldPassword: this.oldPassword, newPassword: this.newPassword})
        .then(response => {
          if (response.data.error) {
            this.$noty.error(response.data.error)
            this.oldPassword = ''
            this.newPassword = ''
            this.rePassword = ''
          } else {
            this.$noty.success('Password changed successfully.')
            this.oldPassword = ''
            this.newPassword = ''
            this.rePassword = ''
          }
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.tabs {
  margin: 20px;
  .tab-content {
    min-height: 50px;
  }
}

.checkbox {
	display: block !important;
}
</style>



// WEBPACK FOOTER //
// AccountSetting.vue?968b4e3e